import React from 'react'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'

import './assets/stylesheets/main.css'
import ExpensesPage from './pages/ExpensesPage'

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/">
          <Redirect to="/expenses" />
        </Route>
        <Route
          path="/expenses"
          component={ExpensesPage}
          exact
        />
      </Switch>
    </BrowserRouter>
  )
}

export default App
